import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { TopBar, TopBarProps } from "./TopBar";
import { BottomNav } from "./BottomNav";

export interface ScreenProps {
  children: React.ReactNode;
  showTopBar?: boolean;
  showBottomNav?: boolean;
  topBarProps?: TopBarProps;
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  className?: string;
}

export const Screen: React.FC<ScreenProps> = ({
  children,
  showTopBar = true,
  showBottomNav = true,
  topBarProps,
  activeTab = "home",
  onTabChange = () => {},
  className,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const mainRef = useRef<HTMLElement>(null);
  const location = useLocation();

  useEffect(() => {
    // Trigger fade-in animation on mount
    setIsVisible(true);
  }, []);

  useEffect(() => {
    // Scroll to top on route change
    mainRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen w-full bg-background">
      {showTopBar && topBarProps && <TopBar {...topBarProps} />}

      <main
        ref={mainRef}
        className={cn(
          "flex-1 overflow-y-auto overflow-x-hidden",
          "transition-opacity duration-300",
          isVisible ? "opacity-100" : "opacity-0",
          showBottomNav && "pb-20",
          className
        )}
      >
        {children}
      </main>

      {showBottomNav && (
        <BottomNav activeTab={activeTab} onTabChange={onTabChange} />
      )}
    </div>
  );
};
